import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import { EncuestaService } from 'app/main/wizard-cgo/services/encuesta.service';

const moment = require('moment');

@Component({
  selector: 'modal-reco',
  templateUrl: './modal-reco.component.html',
  styleUrls: ['./modal-reco.component.scss']
})
export class ModalRecoComponent implements OnInit {

  idiomaActual:string;
  historialRecuperado: boolean;
  historialCreacion: any[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public datos: any,
    public dialogRef: MatDialogRef<ModalRecoComponent>,
    private translateSrv: TranslateService,
    private encuestaService: EncuestaService,
  ) {
    this.idiomaActual = this.translateSrv.currentLang;
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
  }

  ngOnInit() {
    console.log("datosRecibidos:",this.datos);
    if(this.datos.opcion == 'historial'){
      this.getHistorialCreacionEncuesta();
    }
  }

  getHistorialCreacionEncuesta(){
    this.encuestaService.getHistoriaCreacionEncuesta().subscribe((respuesta:any) => {
      console.log("getHistoriaCreacionEncuesta: ", respuesta);
      if(respuesta.message == 'success'){
        this.historialRecuperado = true;
        this.historialCreacion = respuesta.historial;
        this.historialCreacion.sort( (a,b) => {
          if(moment(a.createdAt).isBefore(moment(b.createdAt))){ return 1; } else{ return -1; }
        });
      }
    }, error => {
      console.log(error);
    });
  }

  salir() {
    this.dialogRef.close();
  }

}
